/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Curve_Max_Offset_Adaptation_UnitInputs */



/**
* | output |
* | --- |
* | "°C" |
*
* @param {Heating_Curve_Max_Offset_Adaptation_UnitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_max_offset_adaptation_unit = /** @type {((inputs?: Heating_Curve_Max_Offset_Adaptation_UnitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Curve_Max_Offset_Adaptation_UnitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("°C")
	return /** @type {LocalizedString} */ ("°C")
});